import { createSelector } from 'reselect';

const getStartupPage = (state) => state.startupPage.startupPage;
const getStartupPageAttempting = (state) => state.startupPage.attempting;
const getStartupPageError = (state) => state.startupPage.errorCode;

export const getStartupPageSelector = createSelector(getStartupPage, (startupPage) => startupPage);
export const getStartupPageAttemptingSelector = createSelector(getStartupPageAttempting, (attempting) => attempting);
export const getStartupPageErrorSelector = createSelector(getStartupPageError, (errorCode) => errorCode);
